import axios from 'axios';

// apiEnv: The environment the component is being hosted on such as "prod" or "dev"
export const getAxiosInstance = apiEnv => {
	// Only add prefix for non-prod environments
	const prefix = apiEnv === 'prod' ? '' : `${apiEnv}.`;
	const baseURL = `https://${prefix}actionplan.api.ashcompanies.com`;

	const instance = axios.create({
		baseURL,
		withCredentials: true,
	});

	return instance;
};
